import { IconsTypesProps } from '../../types';

export const ValveScadaIcon = ({ width = 69, height = 41, fill = '#ECEDEF' }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 69 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.5 20.5L1.5 39.5518V1.44727L34.5 20.5Z"
      fill={fill}
      stroke="#71797D"
      strokeWidth="1.5"
    />
    <path
      d="M67.5 39.5518L34.499 20.5L67.5 1.44727V39.5518Z"
      fill={fill}
      stroke="#71797D"
      strokeWidth="1.5"
    />
  </svg>
);
